webpackJsonp([114276838955818,60335399758886],{

/***/ 97:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(187);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(97);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (typeof Array.from === 'function' ?
	  Array.from :
	  __webpack_require__(156)
	);


/***/ }),

/***/ 156:
/***/ (function(module, exports) {

	// Production steps of ECMA-262, Edition 6, 22.1.2.1
	// Reference: http://www.ecma-international.org/ecma-262/6.0/#sec-array.from
	module.exports = (function() {
	  var isCallable = function(fn) {
	    return typeof fn === 'function';
	  };
	  var toInteger = function (value) {
	    var number = Number(value);
	    if (isNaN(number)) { return 0; }
	    if (number === 0 || !isFinite(number)) { return number; }
	    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
	  };
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	  var toLength = function (value) {
	    var len = toInteger(value);
	    return Math.min(Math.max(len, 0), maxSafeInteger);
	  };
	  var iteratorProp = function(value) {
	    if(value != null) {
	      if(['string','number','boolean','symbol'].indexOf(typeof value) > -1){
	        return Symbol.iterator;
	      } else if (
	        (typeof Symbol !== 'undefined') &&
	        ('iterator' in Symbol) &&
	        (Symbol.iterator in value)
	      ) {
	        return Symbol.iterator;
	      }
	      // Support "@@iterator" placeholder, Gecko 27 to Gecko 35
	      else if ('@@iterator' in value) {
	        return '@@iterator';
	      }
	    }
	  };
	  var getMethod = function(O, P) {
	    // Assert: IsPropertyKey(P) is true.
	    if (O != null && P != null) {
	      // Let func be GetV(O, P).
	      var func = O[P];
	      // ReturnIfAbrupt(func).
	      // If func is either undefined or null, return undefined.
	      if(func == null) {
	        return void 0;
	      }
	      // If IsCallable(func) is false, throw a TypeError exception.
	      if (!isCallable(func)) {
	        throw new TypeError(func + ' is not a function');
	      }
	      return func;
	    }
	  };
	  var iteratorStep = function(iterator) {
	    // Let result be IteratorNext(iterator).
	    // ReturnIfAbrupt(result).
	    var result = iterator.next();
	    // Let done be IteratorComplete(result).
	    // ReturnIfAbrupt(done).
	    var done = Boolean(result.done);
	    // If done is true, return false.
	    if(done) {
	      return false;
	    }
	    // Return result.
	    return result;
	  };
	
	  // The length property of the from method is 1.
	  return function from(items /*, mapFn, thisArg */ ) {
	    'use strict';
	
	    // 1. Let C be the this value.
	    var C = this;
	
	    // 2. If mapfn is undefined, let mapping be false.
	    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
	
	    var T;
	    if (typeof mapFn !== 'undefined') {
	      // 3. else
	      //   a. If IsCallable(mapfn) is false, throw a TypeError exception.
	      if (!isCallable(mapFn)) {
	        throw new TypeError(
	          'Array.from: when provided, the second argument must be a function'
	        );
	      }
	
	      //   b. If thisArg was supplied, let T be thisArg; else let T
	      //      be undefined.
	      if (arguments.length > 2) {
	        T = arguments[2];
	      }
	      //   c. Let mapping be true (implied by mapFn)
	    }
	
	    var A, k;
	
	    // 4. Let usingIterator be GetMethod(items, @@iterator).
	    // 5. ReturnIfAbrupt(usingIterator).
	    var usingIterator = getMethod(items, iteratorProp(items));
	
	    // 6. If usingIterator is not undefined, then
	    if (usingIterator !== void 0) {
	      // a. If IsConstructor(C) is true, then
	      //   i. Let A be the result of calling the [[Construct]]
	      //      internal method of C with an empty argument list.
	      // b. Else,
	      //   i. Let A be the result of the abstract operation ArrayCreate
	      //      with argument 0.
	      // c. ReturnIfAbrupt(A).
	      A = isCallable(C) ? Object(new C()) : [];
	
	      // d. Let iterator be GetIterator(items, usingIterator).
	      var iterator = usingIterator.call(items);
	
	      // e. ReturnIfAbrupt(iterator).
	      if (iterator == null) {
	        throw new TypeError(
	          'Array.from requires an array-like or iterable object'
	        );
	      }
	
	      // f. Let k be 0.
	      k = 0;
	
	      // g. Repeat
	      var next, nextValue;
	      while (true) {
	        // i. Let Pk be ToString(k).
	        // ii. Let next be IteratorStep(iterator).
	        // iii. ReturnIfAbrupt(next).
	        next = iteratorStep(iterator);
	
	        // iv. If next is false, then
	        if (!next) {
	
	          // 1. Let setStatus be Set(A, "length", k, true).
	          // 2. ReturnIfAbrupt(setStatus).
	          A.length = k;
	
	          // 3. Return A.
	          return A;
	        }
	        // v. Let nextValue be IteratorValue(next).
	        // vi. ReturnIfAbrupt(nextValue)
	        nextValue = next.value;
	
	        // vii. If mapping is true, then
	        //   1. Let mappedValue be Call(mapfn, T, «nextValue, k»).
	        //   2. If mappedValue is an abrupt completion, return
	        //      IteratorClose(iterator, mappedValue).
	        //   3. Let mappedValue be mappedValue.[[value]].
	        // viii. Else, let mappedValue be nextValue.
	        // ix.  Let defineStatus be the result of
	        //      CreateDataPropertyOrThrow(A, Pk, mappedValue).
	        // x. [TODO] If defineStatus is an abrupt completion, return
	        //    IteratorClose(iterator, defineStatus).
	        if (mapFn) {
	          A[k] = mapFn.call(T, nextValue, k);
	        }
	        else {
	          A[k] = nextValue;
	        }
	        // xi. Increase k by 1.
	        k++;
	      }
	      // 7. Assert: items is not an Iterable so assume it is
	      //    an array-like object.
	    } else {
	
	      // 8. Let arrayLike be ToObject(items).
	      var arrayLike = Object(items);
	
	      // 9. ReturnIfAbrupt(items).
	      if (items == null) {
	        throw new TypeError(
	          'Array.from requires an array-like object - not null or undefined'
	        );
	      }
	
	      // 10. Let len be ToLength(Get(arrayLike, "length")).
	      // 11. ReturnIfAbrupt(len).
	      var len = toLength(arrayLike.length);
	
	      // 12. If IsConstructor(C) is true, then
	      //     a. Let A be Construct(C, «len»).
	      // 13. Else
	      //     a. Let A be ArrayCreate(len).
	      // 14. ReturnIfAbrupt(A).
	      A = isCallable(C) ? Object(new C(len)) : new Array(len);
	
	      // 15. Let k be 0.
	      k = 0;
	      // 16. Repeat, while k < len… (also steps a - h)
	      var kValue;
	      while (k < len) {
	        kValue = arrayLike[k];
	        if (mapFn) {
	          A[k] = mapFn.call(T, kValue, k);
	        }
	        else {
	          A[k] = kValue;
	        }
	        k++;
	      }
	      // 17. Let setStatus be Set(A, "length", len, true).
	      // 18. ReturnIfAbrupt(setStatus).
	      A.length = len;
	      // 19. Return A.
	    }
	    return A;
	  };
	})();


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(61);
	
	/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */
	
	/**
	 * 1. Change the default font family in all browsers (opinionated).
	 * 2. Correct the line height in all browsers.
	 * 3. Prevent adjustments of font size after orientation changes in
	 *    IE on Windows Phone and in iOS.
	 */
	
	/* Document
	   ========================================================================== */
	
	(0, _index.insertRule)('html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}');
	
	/* Sections
	   ========================================================================== */
	
	/**
	 * Remove the margin in all browsers (opinionated).
	 */
	
	(0, _index.insertRule)('body {\n  margin: 0;\n}');
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	(0, _index.insertRule)('article,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}');
	
	/**
	 * Correct the font size and margin on `h1` elements within `section` and
	 * `article` contexts in Chrome, Firefox, and Safari.
	 */
	
	(0, _index.insertRule)('h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}');
	
	/* Grouping content
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 * 1. Add the correct display in IE.
	 */
	
	(0, _index.insertRule)('figcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}');
	
	/**
	 * Add the correct margin in IE 8.
	 */
	
	(0, _index.insertRule)('figure {\n  margin: 1em 40px;\n}');
	
	/**
	 * 1. Add the correct box sizing in Firefox.
	 * 2. Show the overflow in Edge and IE.
	 */
	
	(0, _index.insertRule)('hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}');
	
	/**
	 * 1. Correct the inheritance and scaling of font size in all browsers.
	 * 2. Correct the odd `em` font sizing in all browsers.
	 */
	
	(0, _index.insertRule)('pre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}');
	
	/* Text-level semantics
	   ========================================================================== */
	
	/**
	 * 1. Remove the gray background on active links in IE 10.
	 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
	 */
	
	(0, _index.insertRule)('a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}');
	
	/**
	 * Remove the outline on focused links when they are also active or hovered
	 * in all browsers (opinionated).
	 */
	
	(0, _index.insertRule)('a:active,\na:hover {\n  outline-width: 0;\n}');
	
	/**
	 * 1. Remove the bottom border in Firefox 39-.
	 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
	 */
	
	(0, _index.insertRule)('abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}');
	
	/**
	 * Prevent the duplicate application of `bolder` by the next rule in Safari 6.
	 */
	
	(0, _index.insertRule)('b,\nstrong {\n  font-weight: inherit;\n}');
	
	/**
	 * Add the correct font weight in Chrome, Edge, and Safari.
	 */
	
	(0, _index.insertRule)('b,\nstrong {\n  font-weight: bolder;\n}');
	
	/**
	 * 1. Correct the inheritance and scaling of font size in all browsers.
	 * 2. Correct the odd `em` font sizing in all browsers.
	 */
	
	(0, _index.insertRule)('code,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}');
	
	/**
	 * Add the correct font style in Android 4.3-.
	 */
	
	(0, _index.insertRule)('dfn {\n  font-style: italic;\n}');
	
	/**
	 * Add the correct background and color in IE 9-.
	 */
	
	(0, _index.insertRule)('mark {\n  background-color: #ff0;\n  color: #000;\n}');
	
	/**
	 * Add the correct font size in all browsers.
	 */
	
	(0, _index.insertRule)('small {\n  font-size: 80%;\n}');
	
	/**
	 * Prevent `sub` and `sup` elements from affecting the line height in
	 * all browsers.
	 */
	
	(0, _index.insertRule)('sub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}');
	
	(0, _index.insertRule)('sub {\n  bottom: -0.25em;\n}');
	
	(0, _index.insertRule)('sup {\n  top: -0.5em;\n}');
	
	/* Embedded content
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	(0, _index.insertRule)('audio,\nvideo {\n  display: inline-block;\n}');
	
	/**
	 * Add the correct display in iOS 4-7.
	 */
	
	(0, _index.insertRule)('audio:not([controls]) {\n  display: none;\n  height: 0;\n}');
	
	/**
	 * Remove the border on images inside links in IE 10-.
	 */
	
	(0, _index.insertRule)('img {\n  border-style: none;\n}');
	
	/**
	 * Hide the overflow in IE.
	 */
	
	(0, _index.insertRule)('svg:not(:root) {\n  overflow: hidden;\n}');
	
	/* Forms
	   ========================================================================== */
	
	/**
	 * 1. Change the font styles in all browsers (opinionated).
	 * 2. Remove the margin in Firefox and Safari.
	 */
	
	(0, _index.insertRule)('button,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}');
	
	/**
	 * Show the overflow in IE.
	 * 1. Show the overflow in Edge.
	 */
	
	(0, _index.insertRule)('button,\ninput { /* 1 */\n  overflow: visible;\n}');
	
	/**
	 * Remove the inheritance of text transform in Edge, Firefox, and IE.
	 * 1. Remove the inheritance of text transform in Firefox.
	 */
	
	(0, _index.insertRule)('button,\nselect { /* 1 */\n  text-transform: none;\n}');
	
	/**
	 * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`
	 *    controls in Android 4.
	 * 2. Correct the inability to style clickable types in iOS and Safari.
	 */
	
	(0, _index.insertRule)('button,\nhtml [type="button"], /* 1 */\n[type="reset"],\n[type="submit"] {\n  -webkit-appearance: button; /* 2 */\n}');
	
	/**
	 * Remove the inner border and padding in Firefox.
	 */
	
	(0, _index.insertRule)('button::-moz-focus-inner,\n[type="button"]::-moz-focus-inner,\n[type="reset"]::-moz-focus-inner,\n[type="submit"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}');
	
	/**
	 * Restore the focus styles unset by the previous rule.
	 */
	
	(0, _index.insertRule)('button:-moz-focusring,\n[type="button"]:-moz-focusring,\n[type="reset"]:-moz-focusring,\n[type="submit"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}');
	
	/**
	 * Change the border, margin, and padding in all browsers (opinionated).
	 */
	
	(0, _index.insertRule)('fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}');
	
	/**
	 * 1. Correct the text wrapping in Edge and IE.
	 * 2. Correct the color inheritance from `fieldset` elements in IE.
	 * 3. Remove the padding so developers are not caught out when they zero out
	 *    `fieldset` elements in all browsers.
	 */
	
	(0, _index.insertRule)('legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}');
	
	/**
	 * 1. Add the correct display in IE 9-.
	 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
	 */
	
	(0, _index.insertRule)('progress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}');
	
	/**
	 * Remove the default vertical scrollbar in IE.
	 */
	
	(0, _index.insertRule)('textarea {\n  overflow: auto;\n}');
	
	/**
	 * 1. Add the correct box sizing in IE 10-.
	 * 2. Remove the padding in IE 10-.
	 */
	
	(0, _index.insertRule)('[type="checkbox"],\n[type="radio"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}');
	
	/**
	 * Correct the cursor style of increment and decrement buttons in Chrome.
	 */
	
	(0, _index.insertRule)('[type="number"]::-webkit-inner-spin-button,\n[type="number"]::-webkit-outer-spin-button {\n  height: auto;\n}');
	
	/**
	 * 1. Correct the odd appearance in Chrome and Safari.
	 * 2. Correct the outline style in Safari.
	 */
	
	(0, _index.insertRule)('[type="search"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}');
	
	/**
	 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
	 */
	
	(0, _index.insertRule)('[type="search"]::-webkit-search-cancel-button,\n[type="search"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}');
	
	/**
	 * 1. Correct the inability to style clickable types in iOS and Safari.
	 * 2. Change font properties to `inherit` in Safari.
	 */
	
	(0, _index.insertRule)('::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}');
	
	/* Interactive
	   ========================================================================== */
	
	/*
	 * Add the correct display in IE 9-.
	 * 1. Add the correct display in Edge, IE, and Firefox.
	 */
	
	(0, _index.insertRule)('details, /* 1 */\nmenu {\n  display: block;\n}');
	
	/*
	 * Add the correct display in all browsers.
	 */
	
	(0, _index.insertRule)('summary {\n  display: list-item;\n}');
	
	/* Scripting
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	(0, _index.insertRule)('canvas {\n  display: inline-block;\n}');
	
	/**
	 * Add the correct display in IE.
	 */
	
	(0, _index.insertRule)('template {\n  display: none;\n}');
	
	/* Hidden
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 10-.
	 */
	
	(0, _index.insertRule)('[hidden] {\n  display: none;\n}');

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(674)


/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

	/*! https://mths.be/includes v0.2.0 by @mathias */
	if (!String.prototype.includes) {
		(function() {
			'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
			var toString = {}.toString;
			var defineProperty = (function() {
				// IE 8 only supports `Object.defineProperty` on DOM elements
				try {
					var object = {};
					var $defineProperty = Object.defineProperty;
					var result = $defineProperty(object, object, object) && $defineProperty;
				} catch(error) {}
				return result;
			}());
			var indexOf = ''.indexOf;
			var includes = function(search) {
				if (this == null) {
					throw TypeError();
				}
				var string = String(this);
				if (search && toString.call(search) == '[object RegExp]') {
					throw TypeError();
				}
				var stringLength = string.length;
				var searchString = String(search);
				var searchLength = searchString.length;
				var position = arguments.length > 1 ? arguments[1] : undefined;
				// `ToInteger`
				var pos = position ? Number(position) : 0;
				if (pos != pos) { // better `isNaN`
					pos = 0;
				}
				var start = Math.min(Math.max(pos, 0), stringLength);
				// Avoid the `indexOf` call if no match is possible
				if (searchLength + start > stringLength) {
					return false;
				}
				return indexOf.call(string, searchString, pos) != -1;
			};
			if (defineProperty) {
				defineProperty(String.prototype, 'includes', {
					'value': includes,
					'configurable': true,
					'writable': true
				});
			} else {
				String.prototype.includes = includes;
			}
		}());
	}


/***/ }),

/***/ 1133:
/***/ (function(module, exports) {

	/*! http://mths.be/repeat v0.2.0 by @mathias */
	if (!String.prototype.repeat) {
		(function() {
			'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
			var defineProperty = (function() {
				// IE 8 only supports `Object.defineProperty` on DOM elements
				try {
					var object = {};
					var $defineProperty = Object.defineProperty;
					var result = $defineProperty(object, object, object) && $defineProperty;
				} catch(error) {}
				return result;
			}());
			var repeat = function(count) {
				if (this == null) {
					throw TypeError();
				}
				var string = String(this);
				// `ToInteger`
				var n = count ? Number(count) : 0;
				if (n != n) { // better `isNaN`
					n = 0;
				}
				// Account for out-of-bounds indices
				if (n < 0 || n == Infinity) {
					throw RangeError();
				}
				var result = '';
				while (n) {
					if (n % 2 == 1) {
						result += string;
					}
					if (n > 1) {
						string += string;
					}
					n >>= 1;
				}
				return result;
			};
			if (defineProperty) {
				defineProperty(String.prototype, 'repeat', {
					'value': repeat,
					'configurable': true,
					'writable': true
				});
			} else {
				String.prototype.repeat = repeat;
			}
		}());
	}


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	var _ExternalLinkSvg = __webpack_require__(67);
	
	var _ExternalLinkSvg2 = _interopRequireDefault(_ExternalLinkSvg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalFooterLink = function ExternalFooterLink(_ref) {
	  var children = _ref.children,
	      href = _ref.href,
	      target = _ref.target,
	      rel = _ref.rel;
	  return Glamor.createElement(
	    'a',
	    {
	      css: {
	        lineHeight: 2,
	        ':hover': {
	          color: _theme.colors.brand
	        }
	      },
	      href: href,
	      target: target,
	      rel: rel },
	    children,
	    Glamor.createElement(_ExternalLinkSvg2.default, {
	      cssProps: {
	        verticalAlign: -2,
	        display: 'inline-block',
	        marginLeft: 5,
	        color: _theme.colors.subtle
	      }
	    })
	  );
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */
	
	exports.default = ExternalFooterLink;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _Container = __webpack_require__(7);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ExternalFooterLink = __webpack_require__(174);
	
	var _ExternalFooterLink2 = _interopRequireDefault(_ExternalFooterLink);
	
	var _FooterLink = __webpack_require__(176);
	
	var _FooterLink2 = _interopRequireDefault(_FooterLink);
	
	var _FooterNav = __webpack_require__(177);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	var _MetaTitle = __webpack_require__(47);
	
	var _MetaTitle2 = _interopRequireDefault(_MetaTitle);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	var _oss_logo = __webpack_require__(1139);
	
	var _oss_logo2 = _interopRequireDefault(_oss_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var Footer = function Footer(_ref) {
	  var _ref2, _ref3, _ref4, _ref5;
	
	  var _ref$layoutHasSidebar = _ref.layoutHasSidebar,
	      layoutHasSidebar = _ref$layoutHasSidebar === undefined ? false : _ref$layoutHasSidebar;
	  return Glamor.createElement(
	    'footer',
	    {
	      css: (_ref2 = {
	        backgroundColor: _theme.colors.darker,
	        color: _theme.colors.white,
	        paddingTop: 10,
	        paddingBottom: 50
	
	      }, _ref2[_theme.media.size('sidebarFixed')] = {
	        paddingTop: 40
	      }, _ref2) },
	    Glamor.createElement(
	      _Container2.default,
	      null,
	      Glamor.createElement(
	        'div',
	        {
	          css: (_ref3 = {
	            display: 'flex',
	            flexDirection: 'row',
	            flexWrap: 'wrap'
	
	          }, _ref3[_theme.media.between('small', 'medium')] = {
	            paddingRight: layoutHasSidebar ? 240 : null
	          }, _ref3[_theme.media.between('large', 'largerSidebar')] = {
	            paddingRight: layoutHasSidebar ? 280 : null
	          }, _ref3[_theme.media.between('largerSidebar', 'sidebarFixed', true)] = {
	            paddingRight: layoutHasSidebar ? 380 : null
	          }, _ref3) },
	        Glamor.createElement(
	          'div',
	          {
	            css: (_ref4 = {
	              flexWrap: 'wrap',
	              display: 'flex'
	
	            }, _ref4[_theme.media.lessThan('large')] = {
	              width: '100%'
	            }, _ref4[_theme.media.greaterThan('xlarge')] = {
	              width: 'calc(100% / 3 * 2)',
	              paddingLeft: 40
	            }, _ref4) },
	          Glamor.createElement(
	            _FooterNav2.default,
	            { layoutHasSidebar: layoutHasSidebar },
	            Glamor.createElement(
	              _MetaTitle2.default,
	              { onDark: true },
	              '\u6587\u6863'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/docs/hello-world.html' },
	              '\u5FEB\u901F\u5F00\u59CB'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/docs/thinking-in-react.html' },
	              'React \u7406\u5FF5'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/tutorial/tutorial.html' },
	              '\u5165\u95E8\u6559\u7A0B'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/docs/jsx-in-depth.html' },
	              '\u9AD8\u7EA7\u6307\u5F15'
	            )
	          ),
	          Glamor.createElement(
	            _FooterNav2.default,
	            { layoutHasSidebar: layoutHasSidebar },
	            Glamor.createElement(
	              _MetaTitle2.default,
	              { onDark: true },
	              '\u793E\u533A'
	            ),
	            Glamor.createElement(
	              _ExternalFooterLink2.default,
	              {
	                href: 'http://stackoverflow.com/questions/tagged/reactjs',
	                target: '_blank',
	                rel: 'noopener' },
	              'Stack Overflow'
	            ),
	            Glamor.createElement(
	              _ExternalFooterLink2.default,
	              {
	                href: 'https://discuss.reactjs.org',
	                target: '_blank',
	                rel: 'noopener' },
	              'Discussion \u8BBA\u575B'
	            ),
	            Glamor.createElement(
	              _ExternalFooterLink2.default,
	              {
	                href: 'https://discord.gg/0ZcbPKXt5bZjGY5n',
	                target: '_blank',
	                rel: 'noopener' },
	              'Reactiflux \u804A\u5929\u5BA4'
	            ),
	            Glamor.createElement(
	              _ExternalFooterLink2.default,
	              {
	                href: 'https://www.facebook.com/react',
	                target: '_blank',
	                rel: 'noopener' },
	              'Facebook'
	            ),
	            Glamor.createElement(
	              _ExternalFooterLink2.default,
	              {
	                href: 'https://twitter.com/reactjs',
	                target: '_blank',
	                rel: 'noopener' },
	              'Twitter'
	            )
	          ),
	          Glamor.createElement(
	            _FooterNav2.default,
	            { layoutHasSidebar: layoutHasSidebar },
	            Glamor.createElement(
	              _MetaTitle2.default,
	              { onDark: true },
	              '\u53C2\u8003\u8D44\u6599'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/community/conferences.html' },
	              '\u4F1A\u8BAE'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/community/videos.html' },
	              '\u89C6\u9891'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/community/examples.html' },
	              '\u793A\u4F8B'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/community/debugging-tools.html' },
	              '\u5F00\u53D1\u5DE5\u5177'
	            )
	          ),
	          Glamor.createElement(
	            _FooterNav2.default,
	            { layoutHasSidebar: layoutHasSidebar },
	            Glamor.createElement(
	              _MetaTitle2.default,
	              { onDark: true },
	              '\u5176\u4ED6'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/blog/' },
	              '\u535A\u5BA2'
	            ),
	            Glamor.createElement(
	              _ExternalFooterLink2.default,
	              {
	                href: 'https://github.com/facebook/react',
	                target: '_blank',
	                rel: 'noopener' },
	              'GitHub'
	            ),
	            Glamor.createElement(
	              _ExternalFooterLink2.default,
	              {
	                href: 'http://facebook.github.io/react-native/',
	                target: '_blank',
	                rel: 'noopener' },
	              'React Native'
	            ),
	            Glamor.createElement(
	              _FooterLink2.default,
	              { to: '/acknowledgements.html' },
	              '\u81F4\u8C22'
	            )
	          )
	        ),
	        Glamor.createElement(
	          'section',
	          {
	            css: (_ref5 = {
	              paddingTop: 40,
	              display: 'block !important' }, _ref5[_theme.media.greaterThan('xlarge')] = {
	              width: 'calc(100% / 3)',
	              order: -1
	            }, _ref5[_theme.media.greaterThan('large')] = {
	              order: -1,
	              width: layoutHasSidebar ? null : 'calc(100% / 3)'
	            }, _ref5[_theme.media.lessThan('large')] = {
	              textAlign: 'center',
	              width: '100%',
	              paddingTop: 40
	            }, _ref5) },
	          Glamor.createElement(
	            'a',
	            {
	              href: 'https://code.facebook.com/projects/',
	              target: '_blank',
	              rel: 'noopener' },
	            Glamor.createElement('img', {
	              alt: 'Facebook Open Source',
	              css: {
	                maxWidth: 160,
	                height: 'auto'
	              },
	              src: _oss_logo2.default
	            })
	          ),
	          Glamor.createElement(
	            'p',
	            {
	              css: {
	                color: _theme.colors.subtleOnDark,
	                paddingTop: 15
	              } },
	            'Copyright \xA9 2017 Facebook Inc.'
	          ),
	          Glamor.createElement(
	            'p',
	            {
	              css: {
	                color: _theme.colors.subtleOnDark,
	                paddingTop: 15
	              } },
	            Glamor.createElement(
	              'a',
	              { href: 'https://docschina.org/', target: '_blank' },
	              '\u5370\u8BB0\u4E2D\u6587'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterLink = function FooterLink(_ref) {
	  var children = _ref.children,
	      target = _ref.target,
	      to = _ref.to;
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    {
	      css: {
	        lineHeight: 2,
	        ':hover': {
	          color: _theme.colors.brand
	        }
	      },
	      to: to,
	      target: target },
	    children
	  );
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */
	
	exports.default = FooterLink;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var FooterNav = function FooterNav(_ref) {
	  var _ref2;
	
	  var children = _ref.children,
	      title = _ref.title,
	      _ref$layoutHasSidebar = _ref.layoutHasSidebar,
	      layoutHasSidebar = _ref$layoutHasSidebar === undefined ? false : _ref$layoutHasSidebar;
	  return Glamor.createElement(
	    'div',
	    {
	      css: (_ref2 = {
	        display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'flex-start',
	        width: '50%',
	        paddingTop: 40
	
	      }, _ref2[_theme.media.size('sidebarFixed')] = {
	        paddingTop: 0,
	        width: '25%'
	      }, _ref2) },
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'inline-flex',
	          flexDirection: 'column'
	        } },
	      children
	    )
	  );
	};
	
	exports.default = FooterNav;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Footer = __webpack_require__(175);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Footer2.default; /**
	                                     * Copyright (c) 2013-present, Facebook, Inc.
	                                     *
	                                     * @emails react-core
	                                     */

	module.exports = exports['default'];

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @emails react-core
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var DocSearch = function (_Component) {
	  _inherits(DocSearch, _Component);
	
	  function DocSearch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DocSearch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      enabled: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DocSearch.prototype.componentDidMount = function componentDidMount() {
	    // Initialize Algolia search.
	    // TODO Is this expensive? Should it be deferred until a user is about to search?
	    // eslint-disable-next-line no-undef
	    if (window.docsearch) {
	      window.docsearch({
	        apiKey: 'fb1476c24383a4a7a8d944449c21fdba',
	        indexName: 'react_china',
	        inputSelector: '#algolia-doc-search'
	      });
	    } else {
	      console.warn('Search has failed to load and now is being disabled');
	      this.setState({ enabled: false });
	    }
	  };
	
	  DocSearch.prototype.render = function render() {
	    var _ref, _ref2;
	
	    var enabled = this.state.enabled;
	
	
	    return enabled ? Glamor.createElement(
	      'form',
	      {
	        css: (_ref = {
	          display: 'flex',
	          flex: '0 0 auto',
	          flexDirection: 'row',
	          alignItems: 'center',
	          paddingLeft: '0.5rem',
	          paddingRight: '0.5rem'
	
	        }, _ref[_theme.media.lessThan('small')] = {
	          justifyContent: 'flex-end'
	        }, _ref[_theme.media.lessThan('large')] = {
	          marginRight: 10
	        }, _ref[_theme.media.between('small', 'medium')] = {
	          width: 'calc(100% / 3)'
	        }, _ref[_theme.media.between('medium', 'xlarge')] = {
	          width: 'calc(100% / 6)'
	        }, _ref[_theme.media.greaterThan('small')] = {
	          minWidth: 120
	        }, _ref) },
	      Glamor.createElement('input', {
	        css: (_ref2 = {
	          appearance: 'none',
	          background: 'transparent',
	          border: 0,
	          color: _theme.colors.white,
	          fontSize: 18,
	          fontWeight: 300,
	          fontFamily: 'inherit',
	          position: 'relative',
	          padding: '5px 5px 5px 29px',
	          backgroundImage: 'url(/search.svg)',
	          backgroundSize: '16px 16px',
	          backgroundRepeat: 'no-repeat',
	          backgroundPositionY: 'center',
	          backgroundPositionX: '5px',
	
	          ':focus': {
	            outline: 0,
	            backgroundColor: _theme.colors.lighter,
	            borderRadius: '0.25rem'
	          }
	
	        }, _ref2[_theme.media.lessThan('large')] = {
	          fontSize: 16
	        }, _ref2[_theme.media.greaterThan('small')] = {
	          width: '100%'
	        }, _ref2[_theme.media.lessThan('small')] = {
	          width: '16px',
	          transition: 'width 0.2s ease, padding 0.2s ease',
	          paddingLeft: '16px',
	
	          ':focus': {
	            paddingLeft: '29px',
	            width: '8rem',
	            outline: 'none'
	          }
	        }, _ref2),
	        id: 'algolia-doc-search',
	        type: 'search',
	        placeholder: '\u5728\u6587\u6863\u4E2D\u641C\u7D22...',
	        'aria-label': 'Search docs'
	      })
	    ) : null;
	  };
	
	  return DocSearch;
	}(_react.Component);
	
	exports.default = DocSearch;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @emails react-core
	                                                                                                                                                                                                                                                                   * 
	                                                                                                                                                                                                                                                                   */
	
	var _Container = __webpack_require__(7);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _HeaderLink = __webpack_require__(181);
	
	var _HeaderLink2 = _interopRequireDefault(_HeaderLink);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	var _siteConstants = __webpack_require__(34);
	
	var _ExternalLinkSvg = __webpack_require__(67);
	
	var _ExternalLinkSvg2 = _interopRequireDefault(_ExternalLinkSvg);
	
	var _DocSearch = __webpack_require__(179);
	
	var _DocSearch2 = _interopRequireDefault(_DocSearch);
	
	var _logo = __webpack_require__(1138);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var _ref2, _ref3, _ref4, _ref5, _ref6;
	
	  var location = _ref.location;
	  return Glamor.createElement(
	    'header',
	    {
	      css: {
	        backgroundColor: _theme.colors.darker,
	        color: _theme.colors.white,
	        position: 'fixed',
	        zIndex: 1,
	        width: '100%',
	        top: 0,
	        left: 0
	      } },
	    Glamor.createElement(
	      _Container2.default,
	      null,
	      Glamor.createElement(
	        'div',
	        {
	          css: (_ref2 = {
	            display: 'flex',
	            flexDirection: 'row',
	            alignItems: 'center',
	            height: 60
	          }, _ref2[_theme.media.between('small', 'large')] = {
	            height: 50
	          }, _ref2[_theme.media.lessThan('small')] = {
	            height: 40
	          }, _ref2) },
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          {
	            css: (_ref3 = {
	              display: 'flex',
	              marginRight: 10,
	              height: '100%',
	              alignItems: 'center',
	              color: _theme.colors.brand,
	
	              ':focus': {
	                outline: 0,
	                color: _theme.colors.white
	              }
	
	            }, _ref3[_theme.media.greaterThan('small')] = {
	              width: 'calc(100% / 6)'
	            }, _ref3[_theme.media.lessThan('small')] = {
	              flex: '0 0 auto'
	            }, _ref3),
	            to: '/' },
	          Glamor.createElement('img', { src: _logo2.default, alt: '', height: '20' }),
	          Glamor.createElement(
	            'span',
	            {
	              css: (_ref4 = {
	                color: 'inherit',
	                marginLeft: 10,
	                fontWeight: 700,
	                fontSize: 20,
	                lineHeight: '20px'
	              }, _ref4[_theme.media.lessThan('large')] = {
	                fontSize: 16,
	                marginTop: 1
	              }, _ref4[_theme.media.lessThan('small')] = {
	                // Visually hidden
	                position: 'absolute',
	                overflow: 'hidden',
	                clip: 'rect(0 0 0 0)',
	                height: 1,
	                width: 1,
	                margin: -1,
	                padding: 0,
	                border: 0
	              }, _ref4) },
	            'React'
	          )
	        ),
	        Glamor.createElement(
	          'nav',
	          {
	            css: (_ref5 = {
	              display: 'flex',
	              flexDirection: 'row',
	              alignItems: 'stretch',
	              overflowX: 'auto',
	              overflowY: 'hidden',
	              WebkitOverflowScrolling: 'touch',
	              height: '100%',
	              width: '60%'
	
	            }, _ref5[_theme.media.size('xsmall')] = {
	              flexGrow: '1',
	              width: 'auto'
	            }, _ref5[_theme.media.greaterThan('xlarge')] = {
	              width: null
	            }, _ref5[_theme.media.lessThan('small')] = {
	              maskImage: 'linear-gradient(to right, transparent, black 20px, black 90%, transparent)'
	            }, _ref5) },
	          Glamor.createElement(_HeaderLink2.default, {
	            isActive: location.pathname.includes('/docs/'),
	            title: '\u6587\u6863',
	            to: '/docs/hello-world.html'
	          }),
	          Glamor.createElement(_HeaderLink2.default, {
	            isActive: location.pathname.includes('/tutorial/'),
	            title: '\u6559\u7A0B',
	            to: '/tutorial/tutorial.html'
	          }),
	          Glamor.createElement(_HeaderLink2.default, {
	            isActive: location.pathname.includes('/community/'),
	            title: '\u793E\u533A',
	            to: '/community/support.html'
	          }),
	          Glamor.createElement(_HeaderLink2.default, {
	            isActive: location.pathname.includes('/blog'),
	            title: '\u535A\u5BA2',
	            to: '/blog/'
	          })
	        ),
	        Glamor.createElement(_DocSearch2.default, null),
	        Glamor.createElement(
	          'div',
	          {
	            css: (_ref6 = {}, _ref6[_theme.media.lessThan('medium')] = {
	              display: 'none'
	            }, _ref6[_theme.media.greaterThan('large')] = {
	              width: 'calc(100% / 6)'
	            }, _ref6) },
	          Glamor.createElement(
	            'a',
	            {
	              css: _extends({
	                padding: '5px 10px',
	                whiteSpace: 'nowrap'
	              }, _theme.fonts.small, {
	
	                ':hover': {
	                  color: _theme.colors.brand
	                },
	
	                ':focus': {
	                  outline: 0,
	                  backgroundColor: _theme.colors.lighter,
	                  borderRadius: 15
	                }
	              }),
	              href: '/versions' },
	            'v',
	            _siteConstants.version
	          ),
	          Glamor.createElement(
	            'a',
	            {
	              css: _extends({
	                padding: '5px 10px',
	                marginLeft: 10,
	                whiteSpace: 'nowrap'
	              }, _theme.fonts.small, {
	
	                ':hover': {
	                  color: _theme.colors.brand
	                },
	
	                ':focus': {
	                  outline: 0,
	                  backgroundColor: _theme.colors.lighter,
	                  borderRadius: 15
	                }
	              }),
	              href: 'https://github.com/facebook/react/',
	              target: '_blank',
	              rel: 'noopener' },
	            'GitHub',
	            Glamor.createElement(_ExternalLinkSvg2.default, {
	              cssProps: {
	                marginLeft: 5,
	                verticalAlign: -2,
	                color: _theme.colors.subtle
	              }
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _style, _activeStyle, _activeAfterStyle; /**
	                                              * Copyright (c) 2013-present, Facebook, Inc.
	                                              *
	                                              * @emails react-core
	                                              * 
	                                              */
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderLink = function HeaderLink(_ref) {
	  var isActive = _ref.isActive,
	      title = _ref.title,
	      to = _ref.to;
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    { css: [style, isActive && activeStyle], to: to },
	    title,
	    isActive && Glamor.createElement('span', { css: activeAfterStyle })
	  );
	};
	
	var style = (_style = {
	  display: 'flex',
	  flexDirection: 'row',
	  alignItems: 'center',
	  color: _theme.colors.white,
	  transition: 'color 0.2s ease-out',
	  paddingLeft: 15,
	  paddingRight: 15,
	  fontWeight: 300,
	
	  ':focus': {
	    outline: 0,
	    backgroundColor: _theme.colors.lighter,
	    color: _theme.colors.white
	  }
	
	}, _style[_theme.media.size('xsmall')] = {
	  paddingLeft: 8,
	  paddingRight: 8
	}, _style[_theme.media.between('small', 'medium')] = {
	  paddingLeft: 10,
	  paddingRight: 10
	}, _style[_theme.media.greaterThan('xlarge')] = {
	  paddingLeft: 20,
	  paddingRight: 20,
	  fontSize: 18,
	
	  ':hover:not(:focus)': {
	    color: _theme.colors.brand
	  }
	}, _style);
	
	var activeStyle = (_activeStyle = {
	  color: _theme.colors.brand
	
	}, _activeStyle[_theme.media.greaterThan('small')] = {
	  position: 'relative'
	}, _activeStyle);
	
	var activeAfterStyle = (_activeAfterStyle = {}, _activeAfterStyle[_theme.media.greaterThan('small')] = {
	  position: 'absolute',
	  bottom: -1,
	  height: 4,
	  background: _theme.colors.brand,
	  left: 0,
	  right: 0,
	  zIndex: 1
	}, _activeAfterStyle);
	
	exports.default = HeaderLink;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(180);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default; /**
	                                     * Copyright (c) 2013-present, Facebook, Inc.
	                                     *
	                                     * @emails react-core
	                                     */

	module.exports = exports['default'];

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1138:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(155);
	
	__webpack_require__(1132);
	
	__webpack_require__(1133);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Flex = __webpack_require__(17);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _LayoutFooter = __webpack_require__(178);
	
	var _LayoutFooter2 = _interopRequireDefault(_LayoutFooter);
	
	var _LayoutHeader = __webpack_require__(182);
	
	var _LayoutHeader2 = _interopRequireDefault(_LayoutHeader);
	
	var _theme = __webpack_require__(4);
	
	__webpack_require__(195);
	
	__webpack_require__(676);
	
	__webpack_require__(306);
	
	__webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @emails react-core
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Polyfills for IE
	
	
	// Import global styles
	
	
	var Template = function (_Component) {
	  _inherits(Template, _Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _ref;
	
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location;
	
	    // TODO - is there a better way to check if we need we have a sidebar?
	
	    var layoutHasSidebar = false;
	    if (location.pathname.match(/^\/(docs|tutorial|community|blog|contributing|warnings)/)) {
	      layoutHasSidebar = true;
	    }
	
	    return Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'flex',
	          flexDirection: 'column',
	          minHeight: 'calc(100vh - 40px)'
	        } },
	      Glamor.createElement(_LayoutHeader2.default, { location: location }),
	      Glamor.createElement(
	        _Flex2.default,
	        {
	          direction: 'column',
	          shrink: '0',
	          grow: '1',
	          valign: 'stretch',
	          css: (_ref = {
	            flex: '1 0 auto',
	            marginTop: 60
	          }, _ref[_theme.media.between('medium', 'large')] = {
	            marginTop: 50
	          }, _ref[_theme.media.lessThan('medium')] = {
	            marginTop: 40
	          }, _ref) },
	        children()
	      ),
	      Glamor.createElement(_LayoutFooter2.default, { layoutHasSidebar: layoutHasSidebar })
	    );
	  };
	
	  return Template;
	}(_react.Component);
	
	exports.default = Template;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _glamor = __webpack_require__(61);
	
	var _theme = __webpack_require__(4);
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var prismColors = {
	  char: '#D8DEE9',
	  comment: '#999999',
	  keyword: '#c5a5c5',
	  lineHighlight: '#14161a',
	  primitive: '#5a9bcf',
	  string: '#8dc891',
	  variable: '#d7deea',
	  boolean: '#ff8b50',
	  punctuation: '#5FB3B3',
	  tag: '#fc929e',
	  function: '#79b6f2',
	  className: '#FAC863',
	  method: '#6699CC',
	  operator: '#fc929e'
	};
	
	_glamor.css.global('.gatsby-highlight', {
	  background: _theme.colors.dark,
	  color: _theme.colors.white,
	  borderRadius: 10,
	  overflow: 'auto',
	  tabSize: '1.5em'
	});
	
	_glamor.css.global('\n.gatsby-highlight code[class*="gatsby-code-"],\n.gatsby-highlight pre[class*="gatsby-code-"],\n.gatsby-highlight pre.prism-code', {
	  height: 'auto !important',
	  margin: '1rem',
	  fontSize: 14,
	  lineHeight: '20px',
	  whiteSpace: 'pre-wrap',
	  wordBreak: 'break-word'
	});
	
	_glamor.css.global('.gatsby-highlight + .gatsby-highlight', {
	  marginTop: 20
	});
	
	_glamor.css.global('.gatsby-highlight-code-line', {
	  backgroundColor: prismColors.lineHighlight,
	  display: 'block',
	  margin: '-0.125rem calc(-1rem - 15px)',
	  padding: '0.125rem calc(1rem + 15px)'
	});
	
	_glamor.css.global('.token.attr-name', {
	  color: prismColors.keyword
	});
	
	_glamor.css.global('\n.token.comment,\n.token.block-comment,\n.token.prolog,\n.token.doctype,\n.token.cdata', {
	  color: prismColors.comment
	});
	
	_glamor.css.global('\n.token.property,\n.token.number,\n.token.function-name,\n.token.constant,\n.token.symbol,\n.token.deleted', {
	  color: prismColors.primitive
	});
	
	_glamor.css.global('.token.boolean', {
	  color: prismColors.boolean
	});
	
	_glamor.css.global('.token.tag', {
	  color: prismColors.tag
	});
	
	_glamor.css.global('.token.string', {
	  color: prismColors.string
	});
	
	_glamor.css.global('.token.punctuation', {
	  color: prismColors.punctuation
	});
	
	_glamor.css.global('\n.token.selector,\n.token.char,\n.token.builtin,\n.token.inserted', {
	  color: prismColors.char
	});
	
	_glamor.css.global('.token.function', {
	  color: prismColors.function
	});
	
	_glamor.css.global('\n.token.operator,\n.token.entity,\n.token.url,\n.token.variable', {
	  color: prismColors.variable
	});
	
	_glamor.css.global('.token.attr-value', {
	  color: prismColors.string
	});
	
	_glamor.css.global('.token.keyword', {
	  color: prismColors.keyword
	});
	
	_glamor.css.global('\n.token.atrule,\n.token.class-name', {
	  color: prismColors.className
	});
	
	_glamor.css.global('.token.important', {
	  fontWeight: 400
	});
	
	_glamor.css.global('.token.bold', {
	  fontWeight: 700
	});
	_glamor.css.global('.token.italic', {
	  fontStyle: 'italic'
	});
	
	_glamor.css.global('.token.entity', {
	  cursor: 'help'
	});
	
	_glamor.css.global('.namespace', {
	  opacity: 0.7
	});

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6b8704b264e526819ab0.js